      
//farmers
export const API_FARMERS_LOGIN = 'api/v1/bussines/page/login-group'
export const API_FARMERS_REGISTER = 'api/v1/bussines/group/register-farmer'
export const API_FARMERS_REGISTER_V2 = 'api/v2/bussines/group/register-farmer'
export const API_FARMERS_LIST = 'api/v1/bussines/group/register-farmer'
export const API_FARMERS_PRECHECK = 'api/v1/bussines/group/precheck-farmer'
export const API_FARMERS_UPLOAD_FILE =
  'api/v1/bussines/group/upload-private-file-farmer'
export const API_FARMERS_OCR = 'api/v1/bussines/group/ocr-ktp-farmer'
export const API_FARMERS_PLOTTING = 'api/v1/bussines/group/landplot'
export const API_FARMERS_PLOTTING_SELF = 'api/v1/bussines/self/landplot'
export const API_FARMERS_BANK_LIST = 'api/v1/bussines/group/banks'
export const API_FARMERS_PROVINCE_LIST = 'api/v1/public/wilayah/provinsi'
export const API_FARMERS_CITY_LIST = 'api/v1/public/wilayah/kabkota'
export const API_FARMERS_DISTRICT_LIST = 'api/v1/public/wilayah/kecamatan'
export const API_FARMERS_SUBDISTRICT_LIST = 'api/v1/public/wilayah/kelurahan'
export const API_FARMERS_POSTALCODE_LIST = 'api/v1/public/wilayah/kodepos'
export const API_CHECK_FARMERS = 'api/v1/bussines/group/precheck-farmer'
export const API_INVITE_FARMERS = 'api/v1/bussines/group/invite-farmer'
export const API_CHANGE_NAME = 'api/v1/bussines/group/management/:code/update'
export const API_GROUP_LIST = 'api/v1/bussines/group/management'
export const API_GROUP_LIST_LOT_ID = 'api/v1/bussines/inventorygroups/lotid'
export const API_GROUP_COUNT = 'api/v1/bussines/group/management-count'
export const API_DELETE_GROUP = 'api/v1/bussines/group/management/:code'
export const API_ROLES_PMB = 'api/v1/bussines/role'
export const API_ROLES_FARMERS = 'api/v1/bussines/role?type=group'
export const API_SET_ROLE_PMB = 'api/v1/bussines/team/:userId/set-role'
export const API_SET_ROLE_FARMERS =
  'api/v1/bussines/group/register-farmer/:userId/set-role'
export const API_AGENT_APPROVAL = 'api/v1/bussines/invite-agent'
export const API_CONTENT_TUTORIAL = 'api/v1/bussines/tutorial'
export const API_TUTORIAL_REPORT = 'api/v1/bussines/learning-report'
export const API_TUTORIAL_REPORT_USER =
  'api/v1/bussines/tutorial/tutorial-watch?:userId'
export const API_SUMMARY_FARMERS = 'api/v1/bussines/group/farmer-summary'
export const API_DELETE_FARMERS = 'api/v1/bussines/group/delete-farmer'
export const API_GENERIC_DATA_INSURANCE = 'api/v1/bussines/genericdata/wmdata'

// SHARED GROUPS
export const API_SHARED_GROUPS = 'api/v1/bussines/share/group'
export const API_SHARED_GROUP_FARMERS = 'api/v1/bussines/share/group/register-farmer'
export const API_SHARED_GROUP_FARMER_SUMMARY = 'api/v1/bussines/share/group/farmer-summary'
export const API_SHARED_GROUP_MANAGEMENT = 'api/v1/bussines/share/group/management'
export const API_SHARED_GROUP_MANAGEMENT_COUNT = 'api/v1/bussines/share/group/management-count'
export const API_SHARED_GROUP_LANDPLOT = 'api/v1/bussines/share/group/landplot'
export const API_SHARED_GROUP_LANDPLOTPOINT = 'api/v1/bussines/share/group/landplotpoint'
// VESSELS
export const API_VESSELS_LIST = 'api/v1/bussines/ap2hi/mastervessels'
export const API_VESSELS_ADD = 'api/v1/bussines/ap2hi/mastervessels'
export const API_VESSELS_DELETE = 'api/v1/bussines/ap2hi/mastervessels'
export const API_VESSELS_USERS = 'api/v1/bussines/ap2hi/mastervesselsusers'

// UPLOAD IMAGE PUBLIC
export const API_UPLOAD_IMAGE_PUBLIC = 'api/v1/upload/publicfile'

// CATCHES
export const API_USER_DETAIL_VESSEL = 'api/v1/bussines/ap2hi/uservessels'
export const API_CATCHES = 'api/v1/cms/ap2hi/usercatches'
export const API_BUSINESS_CATCHES = 'api/v1/bussines/ap2hi/usercatches'

// GEARS
export const API_GEARS = 'api/v1/bussines/ap2hi/gears'

// PORTS
export const API_PORTS = 'api/v1/bussines/ap2hi/ports'

// COMPANIES
export const API_COMPANIES = 'api/v1/bussines/ap2hi/companies'

// FISHERIES
export const API_FISHERIES = 'api/v1/bussines/ap2hi/fisheries'

// SPECIES
export const API_SPECIES_LIST = 'api/v1/bussines/ap2hi/config'

// BAITS
export const API_BAITS_LIST = 'api/v1/bussines/ap2hi/baits'

// WHISTLE BLOWINGS
export const API_WHISTLE_BLOWINGS = 'api/v1/bussines/ap2hi/whistleblowings'
export const API_ALL_WHISTLE_BLOWINGS =
  'api/v1/bussines/ap2hi/whistleblowings/all'
export const API_WHISTLE_BLOWINGS_SUMMARY =
  'api/v1/bussines/whistleblowings/summary'

// USERS TIM LIST
export const API_USERS_TIM_LIST = 'api/v1/bussines/team'

//WAREHOUSE
export const API_WAREHOUSE = 'api/v1/bussines/warehouse'
export const API_WAREHOUSE_STAFF = 'api/v1/bussines/team?isForPicWarehouse=1'
export const API_WAREHOUSE_CREATE = 'api/v1/bussines/warehouse'
export const API_WAREHOUSE_SUMMARY = 'api/v1/bussines/warehouse-summary'
export const API_WAREHOUSE_NETWORK_SUMMARY =
  'api/v1/bussines/warehouse/network/summary'
export const API_WAREHOUSE_NETWORK_ITEMS =
  'api/v1/bussines/warehouse/network/items'
export const API_WAREHOUSE_NETWORK_SUMMARY_V2 =
  'api/v1/bussines/warehouse-balance-summary'
export const API_WAREHOUSE_ITEMS =
  'api/v1/bussines/warehouse-items'

// ADDRESS BOOK
export const API_ADDDRESS_BOOK = '/api/v1/bussines/addressbook'
export const API_FIND_ADDDRESS_BOOK = '/api/v1/bussines/findaddressbook'

// TOOLS PNBP
export const API_CONFIGURATIONS = 'api/v1/bussines/pnbp/config'
export const API_REPORT_PNBP = 'api/v1/bussines/pnbp/reports'

//ATTENDANCE SUMMARY
export const API_ATTENDANCE_SUMMARY = 'api/v1/bussines/userattendance/summary'
export const API_ATTENDANCE_REPORT = 'api/v1/bussines/userattendance/report'

// FINDORA SYNC DATA
export const API_FINDORA_SYNC_ITEMS = 'api/v1/bussines/findora/syncdata'
export const API_FINDORA_SYNC_EMPLOYEES =
  'api/v1/bussines/findora/syncemployees'
export const API_FINDORA_ITEMS = 'api/v1/bussines/findora/items'

// FINDORA PRODUCT PROCESS LIST
export const API_FINDORA_PRODUCT_PROCESS_LIST =
  'api/v1/bussines/findora/productprocesslist'
export const API_FINDORA_PRODUCT_PROCESS =
  'api/v1/bussines/findora/productprocess'

// FINDORA PRODUCT MAPPING SCHEMA
export const API_FINDORA_INVENTORY_LIST = 'api/v1/bussines/inventory/selection'
export const API_FINDORA_RESULT_INVENTORY_LIST =
  'api/v1/bussines/findora/workresult2inventory'
export const API_FINDORA_GROUP_MAPPING = 'api/v1/bussines/findora/groupmapping'

// FINDORA LOGS
export const API_FINDORA_LOGS_LIST = 'api/v1/bussines/findora/synclogs'

// FINDORA COMPLIANCE
export const API_FINDORA_COMPLIANCE = 'api/v1/bussines/compliance'
export const API_FINDORA_COMPLIANCE_EXPLAIN = 'api/v1/bussines/compliance/explain'
export const API_FINDORA_COMPLIANCE_PERMISSION_ASK =
  'api/v1/bussines/compliance/permission/ask'
export const API_FINDORA_COMPLIANCE_PERMISSION =
  'api/v1/bussines/compliance/permission'
// ESG reports shared via resource access (resourceId = report owner's userId)
export const API_SHARED_COMPLIANCE = 'api/v1/bussines/share/compliance'

// GRIEVANCE
export const API_GRIEVANCE = 'api/v1/bussines/findora/grievance'

// TRANSACTION ADJUSTMENT SET DRAFT
export const API_ADJUSTMENT_SET_DRAFT = 'api/v1/bussines/draftdata/set'
export const API_ADJUSTMENT_GET_DRAFT = 'api/v1/bussines/draftdata/get'

// PROJECT
export const API_PROJECT = 'api/v1/bussines/project'

//EVENT PARTNER
export const API_EVENT_PARTNER = 'api/v1/bussines/event-partner'

//EVENT
export const API_EVENT = 'api/v1/bussines/events'
export const API_EVENT_UTILS = 'api/v1/bussines/events/utility'

// EVENT PARTICIPANT
export const API_EVENT_PARTICIPANT = 'api/v1/bussines/event-participants'
export const API_EVENT_PARTICIPANT_USERS = 'api/v1/bussines/event-users'

// PROJECT MENU
export const API_PROJECTS_MENU = 'api/v1/bussines/project'
export const API_PROJECTS_SELECTION = 'api/v1/bussines/project_selection'
export const API_LINKTAGS = 'api/v1/bussines/linktags'

//SHARE PROJECT
export const API_SHARE_ACCESS = '/api/v1/bussines/resource_access'
export const API_SHARE_PROJECT = '/api/v1/bussines/share/project'
export const API_SHARE_PROJECT_GOALS = '/api/v1/bussines/share/project_goals'
export const API_SHARE_PROJECT_SUMMARY =
  '/api/v1/bussines/share/project_summary'
export const API_SHARE_PROJECT_DETAIL = '/api/v1/bussines/share/project/:id'
export const API_SHARE_PROJECT_EDIT_GOALS =
  '/api/v1/bussines/share/project_goals/:id'

// MASTER ITEMS & MAP SCHEMA
export const API_USER_ITEMS = 'api/v1/bussines/user-items'
export const API_USER_ITEMS_SELECTION = 'api/v1/bussines/items'
export const API_USER_ITEMS_MAP = 'api/v1/bussines/user-items-map'
export const API_USER_ITEM_PRICES = 'api/v1/bussines/user-item-prices'

// PROJECT SUMMARY DASHBOARD
export const API_PROJECT_SUMMARY_DASHBOARD = 'api/v1/bussines/project_summary'

//PROJECT GOALS
export const API_PROJECT_GOALS = 'api/v1/bussines/project_goals'

// SESSION
export const API_SESSION = 'api/v1/bussines/schemasession'
export const API_SESSION_STOP = 'api/v1/bussines/schemasession/stop'

// SCHEMA
export const API_SCHEMA = 'api/v2/bussines/schema'
export const API_SCHEMA_ADD = 'api/v2/bussines/schema/do'
export const API_SCHEMA_SHARE = 'api/v2/bussines/schema/share'

// SCHEMA V2
export const API_SCHEMA_V2 = 'api/v2/bussines/schema'
export const API_SCHEMA_V2_OUTPUT = 'api/v2/bussines/schema/output'

// EMPLOYEE PAYMENTS
export const API_TEAMS = 'api/v1/bussines/team'
export const API_DISBURSEMENT_HISTORY_LIST =
  'api/v1/bussines/empdisbursebatchlist'
export const API_DISBURSEMENT_BATCH = 'api/v1/bussines/empdisbursebatch'
export const API_DISBURSEMENT_BATCH_DETAIL = 'api/v1/bussines/empdisbursebatch'
export const API_DISBURSEMENT_BATCH_DETAIL_LIST = 'api/v1/bussines/empdisburse'
export const API_DISBURSEMENT_DETAILS = 'api/v1/bussines/empdisbursedetails'
export const API_DISBURSEMENT_AUTO_CALCULATE =
  'api/v1/bussines/empdisbursegenerate'

// INVENTORY LOT ID
export const API_INVENTORY_LOT_ID = 'api/v1/bussines/inventory/lotid'
export const API_INVENTORY_LOT_ID_CHECK =
  'api/v1/bussines/inventory/lotid/check'

//COD
export const API_SELLER_CONFIRM_PAYMENT_COD =
  'api/v1/bussines/transaction/confirmpaymentreleasebyseller'

//MUTATION REPORT
export const API_MUTATION_REPORT = 'api/v1/bussines/laporevents'
export const API_MUTATION_REPORT_DETAIL_INVENTORIES =
  'api/v1/bussines/laporevents/inventories'
export const API_MUTATION_REPORT_DETAIL_SUMMARY =
  'api/v1/bussines/laporevents/summary'

//DASHBOARD TRACEABILITY
export const API_DASHBOARD_TRACEABILITY_CONFIG =
  'api/v1/bussines/dashboardtraceability/config'
export const API_DASHBOARD_TRACEABILITY_INVENTORY =
  'api/v1/bussines/dashboardtraceability/inventories'
export const API_DASHBOARD_TRACEABILITY_SUMMARY =
  'api/v1/bussines/dashboardtraceability/summary'
export const API_DASHBOARD_TRACEABILITY_INVENTORYV2 =
  'api/v1/bussines/dashboardtraceability/v2/inventories'
export const API_DASHBOARD_TRACEABILITY_SUMMARYV2 =
  'api/v1/bussines/dashboardtraceability/v2/summary'

export const API_EDIT_NO_TRX = 'api/v1/bussines/transaction/transactionnumber'
export const API_EDIT_PROJECT = 'api/v1/bussines/transaction/project'
export const API_TRANSACTION_PAYMENT = 'api/v1/bussines/transaction/payment'
export const API_TRANSACTION_ARCHIVE = 'api/v2/bussines/transaction-archive'


    